// // import React, { useState, useEffect } from "react";
// // import { useNavigate } from "react-router-dom";
// // import { Eye, EyeOff, Lock, User } from "lucide-react";
// // import "./Login.css";

// // const Login = ({ user, onLogin }) => {
// //   const [username, setUsername] = useState("");
// //   const [password, setPassword] = useState("");
// //   const [error, setError] = useState("");
// //   const [showPassword, setShowPassword] = useState(false);
// //   const navigate = useNavigate();

// //   useEffect(() => {
// //     if (user) {
// //       const path =
// //         user.role === "admin" ? "/admin/dashboard" : "/operator/home";
// //       navigate(path, { replace: true });
// //     }
// //   }, [user, navigate]);

// //   const dummyUsers = [
// //     { username: "admin", password: "admin123", role: "admin" },
// //     { username: "operator", password: "operator123", role: "operator" },
// //   ];

// //   const handleSubmit = (e) => {
// //     e.preventDefault();
// //     setError("");

// //     const foundUser = dummyUsers.find(
// //       (u) => u.username === username && u.password === password
// //     );

// //     if (foundUser) {
// //       onLogin(foundUser);
// //     } else {
// //       setError("Invalid username or password");
// //     }
// //   };

// //   return (
// //     <div className="rv-login__container">
// //       <div className="rv-login__background">
// //         <div className="rv-login__bg-shape rv-login__bg-shape--1"></div>
// //         <div className="rv-login__bg-shape rv-login__bg-shape--2"></div>
// //         <div className="rv-login__bg-shape rv-login__bg-shape--3"></div>
// //       </div>

// //       <div className="rv-login__content">
// //         <div className="rv-login__card">
// //           <div className="rv-login__card-left">
// //             <img
// //               src="/resh-log.png"
// //               alt="Reshview Logo"
// //               className="rv-login__logo"
// //             />
// //             <h2 className="rv-login__title">Reshview Stock Management</h2>
// //             <p className="rv-login__subtitle">
// //               Track inventory, manage operators and keep your stock in sync
// //               across your business.
// //             </p>
// //           </div>

// //           <div className="rv-login__card-right">
// //             <div className="rv-login__logo-mobile">
// //               <img
// //                 src="/resh-log.png"
// //                 alt="Reshview Logo"
// //                 className="rv-login__logo"
// //               />
// //             </div>

// //             <div className="rv-login__header">
// //               <h1 className="rv-login__heading">Welcome Back</h1>
// //               <p className="rv-login__text">
// //                 Sign in to continue to Reshview Stock Management
// //               </p>
// //             </div>

// //             <form onSubmit={handleSubmit} className="rv-login__form">
// //               <div className="rv-login__field">
// //                 <label className="rv-login__label">Username</label>
// //                 <div className="rv-login__input-wrapper">
// //                   <User className="rv-login__input-icon" size={20} />
// //                   <input
// //                     type="text"
// //                     className="rv-login__input"
// //                     value={username}
// //                     onChange={(e) => setUsername(e.target.value)}
// //                     placeholder="Enter your username"
// //                     required
// //                   />
// //                 </div>
// //               </div>

// //               <div className="rv-login__field">
// //                 <label className="rv-login__label">Password</label>
// //                 <div className="rv-login__input-wrapper">
// //                   <Lock className="rv-login__input-icon" size={20} />
// //                   <input
// //                     type={showPassword ? "text" : "password"}
// //                     className="rv-login__input"
// //                     value={password}
// //                     onChange={(e) => setPassword(e.target.value)}
// //                     placeholder="Enter your password"
// //                     required
// //                   />
// //                   <button
// //                     type="button"
// //                     className="rv-login__password-toggle"
// //                     onClick={() => setShowPassword(!showPassword)}
// //                     tabIndex="-1"
// //                   >
// //                     {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
// //                   </button>
// //                 </div>
// //               </div>

// //               {error && (
// //                 <div className="rv-login__error">
// //                   <span>{error}</span>
// //                 </div>
// //               )}

// //               <button type="submit" className="rv-login__button">
// //                 Sign In
// //               </button>
// //             </form>

// //             <div className="rv-login__footer">
// //               <div className="rv-login__demo">
// //                 <p className="rv-login__demo-title">Demo Credentials</p>
// //                 <div className="rv-login__demo-list">
// //                   <span className="rv-login__demo-item">
// //                     Admin: admin / admin123
// //                   </span>
// //                   <span className="rv-login__demo-item">
// //                     Operator: operator / operator123
// //                   </span>
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default Login;
// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { Eye, EyeOff, Lock, User } from "lucide-react";
// import "./Login.css";

// const Login = ({ user, onLogin }) => {
//   const [username, setUsername] = useState("");
//   const [password, setPassword] = useState("");
//   const [error, setError] = useState("");
//   const [showPassword, setShowPassword] = useState(false);
//   const navigate = useNavigate();

//   useEffect(() => {
//     if (user) {
//       const path =
//         user.role === "admin" ? "/admin/dashboard" : "/operator/home";
//       navigate(path, { replace: true });
//     }
//   }, [user, navigate]);

//   const dummyUsers = [
//     { username: "admin", password: "admin123", role: "admin" },
//     { username: "operator", password: "operator123", role: "operator" },
//   ];

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     setError("");

//     const foundUser = dummyUsers.find(
//       (u) => u.username === username && u.password === password
//     );

//     if (foundUser) {
//       onLogin(foundUser);
//     } else {
//       setError("Invalid username or password");
//     }
//   };

//   return (
//     <div className="rv-login__container">
//       <div className="rv-login__background">
//         <div className="rv-login__bg-shape rv-login__bg-shape--1"></div>
//         <div className="rv-login__bg-shape rv-login__bg-shape--2"></div>
//         <div className="rv-login__bg-shape rv-login__bg-shape--3"></div>
//       </div>

//       <div className="rv-login__content">
//         <div className="rv-login__card">
//           <div className="rv-login__card-left">
//             <div className="rv-login__logo-wrapper">
//               <div className="rv-login__logo-icon">
//                 <img
//                   src="/resh-log.png"
//                   alt="Reshview Logo"
//                   className="rv-login__logo"
//                 />
//               </div>
//             </div>
//             <h2 className="rv-login__title">Reshview Stock Management</h2>
//             <p className="rv-login__subtitle">
//               Track inventory, manage operators and keep your stock in sync
//               across your business.
//             </p>
//           </div>

//           <div className="rv-login__card-right">
//             <div className="rv-login__logo-mobile">
//               <div className="rv-login__logo-icon">
//                 <img
//                   src="/resh-log.png"
//                   alt="Reshview Logo"
//                   className="rv-login__logo"
//                 />
//               </div>
//             </div>

//             <div className="rv-login__header">
//               <h1 className="rv-login__heading">Welcome Back</h1>
//               <p className="rv-login__text">
//                 Sign in to continue to Reshview Stock Management
//               </p>
//             </div>

//             <form onSubmit={handleSubmit} className="rv-login__form">
//               <div className="rv-login__field">
//                 <label className="rv-login__label">Username</label>
//                 <div className="rv-login__input-wrapper">
//                   <User className="rv-login__input-icon" size={20} />
//                   <input
//                     type="text"
//                     className="rv-login__input"
//                     value={username}
//                     onChange={(e) => setUsername(e.target.value)}
//                     placeholder="Enter your username"
//                     required
//                   />
//                 </div>
//               </div>

//               <div className="rv-login__field">
//                 <label className="rv-login__label">Password</label>
//                 <div className="rv-login__input-wrapper">
//                   <Lock className="rv-login__input-icon" size={20} />
//                   <input
//                     type={showPassword ? "text" : "password"}
//                     className="rv-login__input"
//                     value={password}
//                     onChange={(e) => setPassword(e.target.value)}
//                     placeholder="Enter your password"
//                     required
//                   />
//                   <button
//                     type="button"
//                     className="rv-login__password-toggle"
//                     onClick={() => setShowPassword(!showPassword)}
//                     tabIndex="-1"
//                   >
//                     {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
//                   </button>
//                 </div>
//               </div>

//               {error && (
//                 <div className="rv-login__error">
//                   <span>{error}</span>
//                 </div>
//               )}

//               <button type="submit" className="rv-login__button">
//                 Sign In
//               </button>
//             </form>

//             <div className="rv-login__footer">
//               <div className="rv-login__demo">
//                 <p className="rv-login__demo-title">DEMO CREDENTIALS</p>
//                 <div className="rv-login__demo-list">
//                   <span className="rv-login__demo-item">
//                     Admin: admin / admin123
//                   </span>
//                   <span className="rv-login__demo-item">
//                     Operator: operator / operator123
//                   </span>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Login;


import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Eye, EyeOff, Lock, User } from "lucide-react";
import "./Login.css";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { login, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      // Admin Home is parked (see App.js), so admins land on Client Management.
      // Point this back at "/admin/home" when that screen is re-enabled.
      const path = user.role === "admin" ? "/admin/add-client" : "/operator/home";
      navigate(path, { replace: true });
    }
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    try {
      await login(username, password);
    } catch (err) {
      setError(err.message || "Invalid username or password");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="rv-login__container">
      <div className="rv-login__background">
        <div className="rv-login__bg-shape rv-login__bg-shape--1"></div>
        <div className="rv-login__bg-shape rv-login__bg-shape--2"></div>
        <div className="rv-login__bg-shape rv-login__bg-shape--3"></div>
      </div>

      <div className="rv-login__content">
        <div className="rv-login__card">
          <div className="rv-login__card-left">
            <div className="rv-login__logo-wrapper">
              <div className="rv-login__logo-icon">
                <img
                  src="/reshview-logo.png"
                  alt="Reshview Logo"
                  className="rv-login__logo"
                  width="120"
                  height="120"
                  loading="eager"
                  decoding="async"
                />
              </div>
            </div>
            <h2 className="rv-login__title">Reshview Stock Management</h2>
            <p className="rv-login__subtitle">
              Track inventory, manage operators and keep your stock in sync
              across your business.
            </p>
          </div>

          <div className="rv-login__card-right">
            <div className="rv-login__logo-mobile">
              <div className="rv-login__logo-icon">
                <img
                  src="/reshview-logo.png"
                  alt="Reshview Logo"
                  className="rv-login__logo"
                  width="120"
                  height="120"
                  loading="eager"
                  decoding="async"
                />
              </div>
            </div>

            <div className="rv-login__header">
              <h1 className="rv-login__heading">Welcome Back</h1>
              <p className="rv-login__text">
                Sign in to continue to Reshview Stock Management
              </p>
            </div>

            <form onSubmit={handleSubmit} className="rv-login__form">
              <div className="rv-login__field">
                <label className="rv-login__label">Username</label>
                <div className="rv-login__input-wrapper">
                  <User className="rv-login__input-icon" size={20} />
                  <input
                    type="text"
                    className="rv-login__input"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    placeholder="Enter your username"
                    required
                    disabled={isLoading}
                  />
                </div>
              </div>

              <div className="rv-login__field">
                <label className="rv-login__label">Password</label>
                <div className="rv-login__input-wrapper">
                  <Lock className="rv-login__input-icon" size={20} />
                  <input
                    type={showPassword ? "text" : "password"}
                    className="rv-login__input"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Enter your password"
                    required
                    disabled={isLoading}
                  />
                  <button
                    type="button"
                    className="rv-login__password-toggle"
                    onClick={() => setShowPassword(!showPassword)}
                    tabIndex="-1"
                    disabled={isLoading}
                  >
                    {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                  </button>
                </div>
              </div>

              {error && (
                <div className="rv-login__error">
                  <span>{error}</span>
                </div>
              )}

              <button
                type="submit"
                className="rv-login__button"
                disabled={isLoading}
              >
                {isLoading ? "Signing in..." : "Sign In"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;